import { render, staticRenderFns } from "./MyCompany.vue?vue&type=template&id=0569838a&"
import script from "./MyCompany.vue?vue&type=script&lang=js&"
export * from "./MyCompany.vue?vue&type=script&lang=js&"
import style0 from "./MyCompany.vue?vue&type=style&index=0&id=0569838a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports